import {merge, pick} from 'lodash-es'
import {FAKE_ADDRESS} from 'modules/checkout/constants'
import {AvailableShippingMethod, CartAddressInput, GetCartQuery,} from '_app/types/api'

export const filterAllowedMethods =
    (locale = 'pl', selectedMethod: string | undefined) =>
        (
            method: AvailableShippingMethod | null
        ): method is AvailableShippingMethod => {
            if (!method) {
                return false
            }

            if (locale === 'pl') {
                // Only display method selected in the previous step
                return selectedMethod === method.carrier_code
            }

            return true
        }

export const getRequiredShippingContactFields = (
    isPickupMethod: boolean
): ApplePayJS.ApplePayContactField[] => [
    ...(isPickupMethod
        ? []
        : (['postalAddress'] as ApplePayJS.ApplePayContactField[])),
    'name',
    'phone',
    'email',
]

export const prepareShippingAddress = (
    data: GetCartQuery | undefined,
    address: Partial<CartAddressInput>
): CartAddressInput => {
    // if there is only one value in the address, split it into street and house number
    // this is happening when choosing a courier delivery method
    if (address?.street?.length === 1 && address.street[0]) {
        const houseNumber = address.street[0].split(/[, ]+/).pop() || ''
        const street = address.street[0]
            .replace(houseNumber ? ` ${houseNumber}` : '', '')
            .trim()
        address.street = [street, houseNumber]
    }

    // Use fake address to make sure every field is present
    // Then use data we already set and override it with the new data
    return merge(
        FAKE_ADDRESS,
        pick(data?.cart?.shipping_addresses?.[0], Object.keys(FAKE_ADDRESS)),
        address
    )
}
